// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lesson-scorm-window .main-content {
  margin: 2em;
}
.lesson-scorm-window .main-content .breadcrumbs {
  margin: 0;
  margin-bottom: 32px;
}
.lesson-scorm-window .main-content .breadcrumbs ol {
  padding-left: 0;
  list-style: none;
  display: flex;
}
.lesson-scorm-window .main-content .breadcrumbs ol a {
  color: #A0A0A0 !important;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0px;
  line-height: 21px;
}
.lesson-scorm-window .main-content .breadcrumbs ol p {
  color: #737373;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0px;
  line-height: 21px;
}
.lesson-scorm-window .main-content .breadcrumbs ol .separator {
  color: #A0A0A0;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0px;
  line-height: 21px;
  margin-right: 10px;
  margin-left: 10px;
}
.lesson-scorm-window .main-content .iframe-parent {
  text-align: center;
}
.lesson-scorm-window .main-content .iframe-parent iframe {
  width: 100%;
  max-width: 1500px;
  max-height: 1500px;
  height: 65vh;
}
`, "",{"version":3,"sources":["webpack://./src/components/LessonScormWindow/styles.less"],"names":[],"mappings":"AAAA;EAGQ,WAAA;AADR;AAFA;EAMY,SAAA;EACA,mBAAA;AADZ;AANA;EAUgB,eAAA;EACA,gBAAA;EACA,aAAA;AADhB;AAXA;EAeoB,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AADpB;AAlBA;EAuBoB,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAFpB;AAzBA;EA+BoB,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAHpB;AAlCA;EA2CY,kBAAA;AANZ;AArCA;EA8CgB,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AANhB","sourcesContent":[".lesson-scorm-window {\n\n    .main-content {\n        margin: 2em;\n\n        .breadcrumbs {\n            margin: 0; \n            margin-bottom: 32px;\n            \n            ol {\n                padding-left: 0;\n                list-style: none;\n                display: flex;  \n\n                a {\n                    color: #A0A0A0 !important; \n                    font-weight: 400;\n                    font-size: 16px;\n                    letter-spacing: 0px;\n                    line-height: 21px;\n                }\n\n                p {\n                    color: #737373; \n                    font-weight: 400;\n                    font-size: 16px;\n                    letter-spacing: 0px;\n                    line-height: 21px;\n                }\n\n                .separator {\n                    color: #A0A0A0; \n                    font-weight: 400;\n                    font-size: 16px;\n                    letter-spacing: 0px;\n                    line-height: 21px;\n                    margin-right: 10px;\n                    margin-left: 10px;\n                }\n            }  \n        }\n        \n        .iframe-parent {\n            text-align: center;\n        \n            iframe {\n                width: 100%;\n                max-width: 1500px;\n                max-height: 1500px;\n                height: 65vh;\n                \n            }\n        } \n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
